import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import {
  MsalInterceptorConfiguration,
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG,
} from '@azure/msal-angular';
import { InteractionType, LogLevel, PublicClientApplication } from '@azure/msal-browser';
import * as Sentry from '@sentry/angular';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { configByUri } from './config-by-uri';

import posthog from 'posthog-js';

if (environment.production) {
  enableProdMode();

  Sentry.init({
    dsn: 'https://a3b8bdf1ec0673b46f26f5f55b9b6ca2@o4509014691348480.ingest.de.sentry.io/4509088253673552',
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}

posthog.init('phc_wtuW2ZpcV5mI4MtAUQe0EWBLlNZ1vyr0kDAdCrtUUZV', {
  api_host: 'https://eu.i.posthog.com',
  person_profiles: 'identified_only', // or 'always' to create profiles for anonymous users as well
});

platformBrowserDynamic([
  {
    provide: MSAL_INSTANCE,
    useValue: new PublicClientApplication({
      auth: {
        // Azure App Registration Client Id
        clientId: configByUri.msalClientId,

        // Microsoft Online login with Tenant Id
        authority: `https://login.microsoftonline.com/f7911bfc-2501-40df-839c-6f8f4b3411e0`,

        // Flow Application Frontend URI
        redirectUri: configByUri.msalRedirectUri,
      },
      cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: false,
      },
    }),
  },
  {
    provide: MSAL_GUARD_CONFIG,
    useValue: null,
  },
  {
    provide: MSAL_INTERCEPTOR_CONFIG,
    useValue: {
      // Use "popup" inside iframe, and "redirect" when opened normally
      interactionType: window !== window.parent && !window.opener ? InteractionType.Popup : InteractionType.Redirect,
      protectedResourceMap: new Map([
        [configByUri.apiUri, [configByUri.msalProtectedResourceUri]],
        // Following scopes are needed for AI memos
        ['https://graph.microsoft.com/v1.0/me/calendarView', ['Calendars.ReadBasic']],
        ['https://graph.microsoft.com/v1.0/me/sendMail', ['Mail.Send']],
      ]),
    } as MsalInterceptorConfiguration,
  },
])
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
